// テーマ外のカスタマイズ用

// タブ切り替え関数
export function initializeTabs(sectionId) {
  const selector = sectionId ? `#${sectionId}` : '';
  
  // 初期化処理 - 最初のタブにactiveクラスを付与
  function setupInitialState() {
    // 最初のメインタブにactiveクラスを付与
    const firstMainTab = document.querySelector(`${selector} .main-tab-nav span`);
    if (firstMainTab) {
      firstMainTab.classList.add('active');
    }
    
    // 最初のコンテンツエリアにactiveクラスを付与
    const firstContentArea = document.querySelector(`${selector} .tab-content-area`);
    if (firstContentArea) {
      firstContentArea.classList.add('active');
    }
    
    // 各コンテンツエリアの最初のサブタブと最初のサブコンテンツにactiveクラスを付与
    document.querySelectorAll(`${selector} .tab-content-area`).forEach(area => {
      const firstSubTab = area.querySelector('.sub-tab-nav span');
      const firstSubContent = area.querySelector('.sub-content');
      
      if (firstSubTab) {
        firstSubTab.classList.add('active');
      }
      if (firstSubContent) {
        firstSubContent.classList.add('active');
      }
    });
  }
  
  // メインタブの制御
  function setupMainTabs() {
    document.querySelectorAll(`${selector} .main-tab-nav span`).forEach((tab, mainIndex) => {
      tab.addEventListener('click', function() {
        // すべてのメインタブを非アクティブにする
        document.querySelectorAll(`${selector} .main-tab-nav span`).forEach(t => {
          t.classList.remove('active');
        });
        
        // すべてのコンテンツエリアを非表示にする
        document.querySelectorAll(`${selector} .tab-content-area`).forEach(area => {
          area.classList.remove('active');
        });
        
        // 選択されたタブとコンテンツをアクティブにする
        this.classList.add('active');
        const targetArea = document.querySelectorAll(`${selector} .tab-content-area`)[mainIndex];
        if (targetArea) {
          targetArea.classList.add('active');
        }
      });
    });
  }
  
  // 初期化実行
  setupInitialState();
  setupMainTabs();
}


// Splideスクロールバー関数
export function createSplideScrollbar(splideElement, scrollbarElement, options = {}) {
  const scrollbar = typeof scrollbarElement === 'string' ?
    document.querySelector(scrollbarElement) :
    scrollbarElement;
  const thumb = scrollbar.querySelector('.splide-scrollbar-thumb');

  if (!scrollbar || !thumb) {
    console.error('Scrollbar or thumb element not found');
    return null;
  }

  let isDragging = false;
  let animationFrame = null;
  let dragAnimationFrame = null;

  // デフォルト設定
  const config = {
    updateTransition: 'all 0.6s cubic-bezier(0.25, 1, 0.5, 1)',
    dragEndTransition: 'all 0.3s ease',
    ...options
  };

  // スクロールバーの位置を更新
  function updateScrollbar() {
    if (isDragging) return;

    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
    }

    animationFrame = requestAnimationFrame(() => {
      const totalSlides = splideElement.length;
      const currentIndex = splideElement.index;
      const maxIndex = splideElement.Components.Controller.getEnd();

      if (maxIndex === 0) return;

      const progress = currentIndex / maxIndex;
      const thumbWidth = (splideElement.options.perPage / totalSlides) * 100;

      thumb.style.transition = config.updateTransition;
      thumb.style.width = thumbWidth + '%';
      thumb.style.left = (progress * (100 - thumbWidth)) + '%';
    });
  }

  // ドラッグ処理
  function handleDrag(clientX) {
    if (!isDragging) return;

    if (dragAnimationFrame) {
      cancelAnimationFrame(dragAnimationFrame);
    }

    dragAnimationFrame = requestAnimationFrame(() => {
      const rect = scrollbar.getBoundingClientRect();
      const clickPosition = clientX - rect.left;
      const scrollbarWidth = rect.width;
      const totalSlides = splideElement.length;
      const thumbWidth = (splideElement.options.perPage / totalSlides) * 100;
      const thumbWidthPx = (thumbWidth / 100) * scrollbarWidth;

      // サムの中心位置を基準に計算
      let newThumbLeft = clickPosition - (thumbWidthPx / 2);
      const maxThumbLeft = scrollbarWidth - thumbWidthPx;
      newThumbLeft = Math.max(0, Math.min(newThumbLeft, maxThumbLeft));

      // パーセンテージに変換
      const newThumbLeftPercent = (newThumbLeft / scrollbarWidth) * 100;
      const maxLeftPercent = 100 - thumbWidth;

      // スクロールバーの位置を直接更新
      thumb.style.transition = 'none';
      thumb.style.left = Math.min(newThumbLeftPercent, maxLeftPercent) + '%';

      // スライダーの位置を計算
      const progress = Math.max(0, Math.min(1, newThumbLeftPercent / maxLeftPercent));
      const targetIndex = Math.round(progress * splideElement.Components.Controller.getEnd());

      splideElement.go(targetIndex, false);
    });
  }

  // イベントリスナーの登録
  function bindEvents() {
    // Splideイベント
    splideElement.on('move', updateScrollbar);
    splideElement.on('moved', updateScrollbar);
    splideElement.on('mounted', updateScrollbar);
    splideElement.on('resize', updateScrollbar);

    // スクロールバーのクリックイベント
    scrollbar.addEventListener('click', function (e) {
      if (e.target === thumb) return;

      const rect = scrollbar.getBoundingClientRect();
      const progress = (e.clientX - rect.left) / rect.width;
      const targetIndex = Math.round(progress * splideElement.Components.Controller.getEnd());

      splideElement.go(targetIndex);
    });

    // マウスドラッグ
    thumb.addEventListener('mousedown', function (e) {
      isDragging = true;
      e.preventDefault();

      function onMouseMove(e) {
        handleDrag(e.clientX);
      }

      function onMouseUp() {
        isDragging = false;
        thumb.style.transition = config.dragEndTransition;
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      }

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    });

    // タッチドラッグ
    thumb.addEventListener('touchstart', function (e) {
      isDragging = true;
      e.preventDefault();

      function onTouchMove(e) {
        handleDrag(e.touches[0].clientX);
      }

      function onTouchEnd() {
        isDragging = false;
        thumb.style.transition = config.dragEndTransition;
        document.removeEventListener('touchmove', onTouchMove);
        document.removeEventListener('touchend', onTouchEnd);
      }

      document.addEventListener('touchmove', onTouchMove);
      document.addEventListener('touchend', onTouchEnd);
    });
  }

  // 破棄処理
  function destroy() {
    if (animationFrame) cancelAnimationFrame(animationFrame);
    if (dragAnimationFrame) cancelAnimationFrame(dragAnimationFrame);

    splideElement.off('move', updateScrollbar);
    splideElement.off('moved', updateScrollbar);
    splideElement.off('mounted', updateScrollbar);
    splideElement.off('resize', updateScrollbar);
  }

  // 初期化
  bindEvents();

  // パブリックAPI
  return {
    update: updateScrollbar,
    destroy: destroy,
    setConfig: (newConfig) => Object.assign(config, newConfig)
  };
}

// ------------------ Splideスクロールバー関数ここまで

// section展開
$(document).on("click", ".toggle-section .toggle-switch", function () {
  $(this).toggleClass("open");
  $(this).next().slideToggle();
  return false;
});

// ドロワーメニュー展開
$(document).on("click", ".menu-drawer__slidemenu li summary", function () {
  $(this).next().addClass("open");
  $(".menu-drawer").addClass("scroll-lock");
  return false;
});
$(document).on("click", ".menu-drawer__parentmenutitle", function () {
  $(this).parent(".menu-drawer__menuwrap").removeClass("open");
  $(".menu-drawer").removeClass("scroll-lock");
  return false;
});